import { createUseStyles } from 'react-jss';

export default createUseStyles({
  inputsGrid: {
    display: 'grid',
    gridTemplateRows: 'repeat(3, 76px)',
    gridRowGap: '24px',
    marginBottom: '24px',
    width: '640px',
    '@media(max-width: 1100px)': {
      width: '80%',
    },
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },

  button: {
    width: '256px',
    '@media(max-width: 900px)': {
      width: '100%',
    }
  },
});
